import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation, useQuery } from "react-query";
import apiClient from '../../request/http-common';
import Alert from '@mui/material/Alert';

const CardActivationSettings = () => {
    const [error, setErros] = useState('');
    const [form, setForm] = useState({
        title: 'Card Activation Fee',
        fee_amount: '',
        fee_message: '',
    });

    const onChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const { isLoading: isLoadingSettings, refetch: loadSettings } = useQuery(
        "card-activation-settings",
        async () => {
          return await apiClient.get("/api/card-activation-settings");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setForm({
                    title: res.data.settings.title || '',
                    fee_amount: res.data.settings.fee_amount || '',
                    fee_message: res.data.settings.fee_message || '',
                });
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: () => {
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
        }
      );

    const { isLoading: isSendingRequest, mutate: saveSettings } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-card-activation-settings`, {
            title: form.title,
            fee_amount: form.fee_amount,
            fee_message: form.fee_message,
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
          onError: (err) => {
            let myerror = err.response?.data || err;
            setErros(myerror.errors || '');
            if (!myerror.errors) {
                let errorMessage = err.response?.data.message || err;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
            }
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
        }
      );

    const onSubmit = () => {
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        saveSettings();
    }

    useEffect(() => {
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        loadSettings();
    }, []);

  return (
    <div style={{marginTop: '70px'}}>
        <Grid container px={2} mt={4} mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <Typography mt={4} sx={{ fontWeight: 'bold', fontSize: 24, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                        CARD ACTIVATION SETTINGS
                    </Typography>
                    <Typography  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        Edit the fee amount and the message users see after they enter a card number to activate.
                    </Typography>

                    <Alert severity="info" sx={{ my: 2, whiteSpace: 'pre-wrap' }}>
                        This message is shown to the user after they submit a valid card number, before they are asked to pay.
                    </Alert>

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="title">Message Title</InputLabel>
                            <OutlinedInput
                            error={Boolean(error !== '' && error.title)}
                            onChange={onChange}
                            value={form.title}
                            id="title"
                            name="title"
                            type={'text'}
                            label="Message Title"
                            />
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.title}
                            </Typography>
                    </FormControl>

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="fee_amount">Activation Fee (USD)</InputLabel>
                            <OutlinedInput
                            error={Boolean(error !== '' && error.fee_amount)}
                            onChange={onChange}
                            value={form.fee_amount}
                            id="fee_amount"
                            name="fee_amount"
                            type={'number'}
                            label="Activation Fee (USD)"
                            />
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.fee_amount}
                            </Typography>
                    </FormControl>

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="fee_message">Fee Message</InputLabel>
                            <OutlinedInput
                            error={Boolean(error !== '' && error.fee_message)}
                            onChange={onChange}
                            value={form.fee_message}
                            id="fee_message"
                            name="fee_message"
                            type={'text'}
                            multiline
                            minRows={8}
                            label="Fee Message"
                            />
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.fee_message}
                            </Typography>
                    </FormControl>
                    </CardContent>

                    <CardActions>
                        <Button onClick={onSubmit} fullWidth={true} size="large" color="primary" variant="contained">
                            {isSendingRequest || isLoadingSettings ? 'Saving...' : 'Save Settings'}
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    </div>
  )
}

export default CardActivationSettings
